/*import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

createApp(App).use(store).use(router).mount('#app')*/
if (window.location.href.includes('%23')) {
    // Ersetze %23 durch #
    const newUrl = window.location.href.replace('%23', '#');

    // Leite zur neuen URL weiter
    window.location.replace(newUrl);
}

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { initializeApp } from 'firebase/app'
import store from "./store";
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import Vue3TouchEvents from "vue3-touch-events";
import { getAuth, setPersistence, browserLocalPersistence, onAuthStateChanged } from 'firebase/auth';

loadFonts();
// Initialize Firebase
const firebaseConfig = {
    apiKey: "AIzaSyCoSXTinPOdm1WkfZb6jvSTsWulm8BURNE",
    authDomain: "hqm-dev.firebaseapp.com",
    databaseURL: "https://hqm-dev-default-rtdb.firebaseio.com",
    projectId: "hqm-dev",
    storageBucket: "hqm-dev.firebasestorage.app",
    messagingSenderId: "86147103044",
    appId: "1:86147103044:web:1d2e9125782d12a3677f11"
};

initializeApp(firebaseConfig)

// Set Firebase Auth persistence to local (persistent login)
const auth = getAuth();
setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error('Error setting Firebase Auth persistence:', error);
});

// Wait for Firebase Auth to initialize before mounting the app
onAuthStateChanged(auth, () => {
  const app = createApp(App);
  app.use(router);
  app.use(store);
  app.use(vuetify);
  app.use(Vue3TouchEvents);
  app.mount('#app');
});
